const Local_URL = "http://127.0.0.1:8000/api";
const Live_URL = "https://www.casino24.com/casino24-web/public/api";
export const BASE_URL = Live_URL;
